export default __webpack_public_path__ + "static/hero-6a7076dd84ec04768d8f01fb74fcc125.jpg";